import './UseOfTextBox.css'

import React from 'react'
import { ActivityStatus, UseOfStatus } from '@/pages/communal/statistics/components/common/data'
import { ActivityStatusChart } from './ActivityStatusChart'
import { HelpPopupButton } from '@/popups/helppopup/help'
import { Services } from '@/services/services'
import { CurrentSession } from '@/services/repository/session'
import { useTranslations } from '@/hooks/useTranslations'
import { TimeDHM } from '@/components/Elements/time'
import { secondsToDHM } from '@/common/time'

type ActivityStatusBoxProps = {
  services: Services
  session: CurrentSession
  status: UseOfStatus
}

export const UseOfTextBox = ({ services, session, status, }: ActivityStatusBoxProps) => {
  const translates = useTranslations(services, session)

  if (translates === undefined) {
    return <div className='spinner'></div>
  }

  return <div className="communal-statistics-useoftext-box">
    <div className="text-stat">
      <h3 className="text-title">
        {translates.for('page.statistics.global.box.useofmachinetext.onfire')}
      </h3>
      <span className="text-value">
        <TimeDHM dhm={secondsToDHM(status.onFireTime)} translates={translates} />
      </span>
    </div>
    <div className="text-stat">
      <h3 className="text-title">
        {translates.for('page.statistics.global.box.useofmachinetext.active')}
      </h3>
      <span className="text-value">
        <TimeDHM dhm={secondsToDHM(status.activeTime)} translates={translates} />
      </span>
    </div>
    <div className="text-stat">
      <h3 className="text-title">
        {translates.for('page.statistics.global.box.useofmachinetext.unused')}
      </h3>
      <span className="text-value">
        <TimeDHM dhm={secondsToDHM(status.totalTime - status.activeTime)} translates={translates} />
      </span>
    </div>
  </div>
}